module.exports = __webpack_public_path__ + "static/media/clothes_pt.788d76ca.png";